// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  updateIssueProjectsRelayMutation,
  updateIssueProjectsRelayMutation$data,
} from './__generated__/updateIssueProjectsRelayMutation.graphql'

type CommitProjectMutationProps = {
  environment: Environment
  connectionId?: string
  projectId: string
  issueId: string
  clientMutationId?: string
  onError?: (error: Error) => void
  onCompleted?: (response: updateIssueProjectsRelayMutation$data) => void
}

export function commitUpdateIssueProjectsMutation({
  environment,
  connectionId,
  projectId,
  issueId,
  clientMutationId,
  onError,
  onCompleted,
}: CommitProjectMutationProps) {
  if (!projectId) return
  return commitMutation<updateIssueProjectsRelayMutation>(environment, {
    mutation: graphql`
      mutation updateIssueProjectsRelayMutation($connections: [ID!]!, $input: AddProjectV2ItemByIdInput!)
      @raw_response_type {
        addProjectV2ItemById(input: $input) {
          projectEdge @appendEdge(connections: $connections) {
            node {
              ...ProjectItemSection
            }
          }
        }
      }
    `,
    variables: {
      input: {contentId: issueId, projectId, clientMutationId},
      connections: connectionId ? [connectionId] : [],
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
